/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：75
 */

"use strict"

export { r as e }
export { o as d }
export { Ffffffff as c }
export { a }
export { s as b }
var r = 360
var o = 640
var /* [auto-meaningful-name] */Ffffffff = "#ffffffff"
var a = 10 * r
var s = 10 * o
export default a
